const NAVIGATION_MENU_LOADING = "NAVIGATION_MENU_LOADING";
const NAVIGATION_MENU_ERROR = "NAVIGATION_MENU_ERROR";
const NAVIGATION_MENU_SUCCESS = "NAVIGATION_MENU_SUCCESS";
const NAVIGATION_SUB_MENU_SUCCESS = "NAVIGATION_SUB_MENU_SUCCESS";

export { NAVIGATION_MENU_LOADING, NAVIGATION_MENU_ERROR, NAVIGATION_MENU_SUCCESS,NAVIGATION_SUB_MENU_SUCCESS };
